import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Popover,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
  IconButton,
  MenuItem,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import styles from "../../../styles.module.css"; // Adjust path as needed
import { useDispatch, useSelector } from "react-redux";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  DeleteDialog,
  ExcelDownload,
  HandleSort,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables"; // Adjust path as needed
import ReactToPrint from "react-to-print";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom"; // Assuming react-router-dom for navigation
import maintenance from "../../../services/maintenance"; // Adjust path as needed
import driveractivityplanning from "../../../services/driveractivityplanning"; // Adjust path as needed
import HeaderSection from "../../reusableComponent/HeaderSection"; // Adjust path as needed
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar"; // Adjust path as needed

// CustomePopover Component
const CustomePopover = ({ row, handleDelete, linkTo, showEdit, handlePrint }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <IconButton aria-describedby={id} onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {showEdit && (
          <MenuItem
            component={Link}
            to={`${linkTo}/${row.entry_id}`}
            onClick={handleClose}
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              padding: "8px 16px",
              fontSize: "14px",
            }}
          >
            <EditIcon style={{ marginRight: "8px" }} />
            Edit
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            handleDelete(row);
            handleClose();
          }}
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            padding: "8px 16px",
            fontSize: "14px",
          }}
        >
          <DeleteIcon style={{ marginRight: "8px" }} />
          Delete
        </MenuItem>
        <ReactToPrint
          trigger={() => (
            <MenuItem
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                padding: "8px 16px",
                fontSize: "14px",
              }}
            >
              <PrintOutlinedIcon style={{ marginRight: "8px" }} />
              Print Record
            </MenuItem>
          )}
          content={handlePrint} // Pass the handlePrint function that returns the ref
        />
      </Popover>
    </div>
  );
};

// ComponentToPrintWrapper for handling print functionality
const ComponentToPrintWrapper = React.forwardRef(({ quotationPrint }, ref) => {
  // Parse table_details safely
  let tableDetails = [];
  try {
    tableDetails = quotationPrint?.table_details ? JSON.parse(quotationPrint.table_details) : [];
  } catch (error) {
    console.error("Error parsing table_details:", error);
  }

  return (
    <div ref={ref} style={{ padding: "20px" }}>
      <div
        style={{
          fontFamily: "Arial, sans-serif",
          fontSize: "14px",
          lineHeight: "1.5",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>Driver Activity Plan</h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",
            marginBottom: "20px",
          }}
        >
          <div>
            <p style={{ margin: "5px 0" }}>
              <strong>Entry No:</strong> {quotationPrint?.entry_no || "N/A"}
            </p>
            <p style={{ margin: "5px 0" }}>
              <strong>Entry Date:</strong>{" "}
              {quotationPrint?.entry_date
                ? new Date(quotationPrint.entry_date).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })
                : "N/A"}
            </p>
            <p style={{ margin: "5px 0" }}>
              <strong>Depot Name:</strong> {quotationPrint?.depot_name || "N/A"}
            </p>
            <p style={{ margin: "5px 0" }}>
              <strong>Driver Name:</strong> {quotationPrint?.driver_name || "N/A"}
            </p>
          </div>
          <div>
            <p style={{ margin: "5px 0" }}>
              <strong>Vehicle No:</strong> {quotationPrint?.vehicle_no || "N/A"}
            </p>
            <p style={{ margin: "5px 0" }}>
              <strong>Start KM:</strong> {quotationPrint?.start_km || "N/A"}
            </p>
            <p style={{ margin: "5px 0" }}>
              <strong>End KM:</strong> {quotationPrint?.end_km || "N/A"}
            </p>
            <p style={{ margin: "5px 0" }}>
              <strong>Start Time:</strong> {quotationPrint?.start_time || "N/A"}
            </p>
            <p style={{ margin: "5px 0" }}>
              <strong>End Time:</strong> {quotationPrint?.end_time || "N/A"}
            </p>
          </div>
        </div>
        <h3 style={{ margin: "20px 0 10px" }}>Activity Details</h3>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            border: "1px solid #000",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  backgroundColor: "#f2f2f2",
                }}
              >
                Sr No
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  backgroundColor: "#f2f2f2",
                }}
              >
                Customer Name
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  backgroundColor: "#f2f2f2",
                }}
              >
                Challan No
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "left",
                  backgroundColor: "#f2f2f2",
                }}
              >
                Activity
              </th>
            </tr>
          </thead>
          <tbody>
            {tableDetails.length > 0 ? (
              tableDetails.map((detail, index) => (
                <tr key={index}>
                  <td style={{ border: "1px solid #000", padding: "8px" }}>{detail.sr_no || "N/A"}</td>
                  <td style={{ border: "1px solid #000", padding: "8px" }}>{detail.customer_name || "N/A"}</td>
                  <td style={{ border: "1px solid #000", padding: "8px" }}>{detail.challan_no || "N/A"}</td>
                  <td style={{ border: "1px solid #000", padding: "8px" }}>{detail.activity || "N/A"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="4"
                  style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}
                >
                  No activity details available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
});

// Main ListDriverActivityPlaning component
const ListDriverActivityPlaning = () => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [sortBy, setSortBy] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const totalCount = useSelector((state) => state.maint_id?.total_count || 0);
  const defaultRowsPerPage = useSelector((state) => state.maint_id?.rows_per_page || 15);
  const [total_count, setTotalCount] = useState(null);

  // Create a ref for each row to be printed
  const printRefs = useRef({});

  useEffect(() => {
    setTotalCount(rows[0]?.totalCount || totalCount);
  }, [rows, totalCount]);

  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage,
  });

  useEffect(() => {
    setController((prev) => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      const response = await driveractivityplanning.getDriverActivityList(params);
      setRows(response);
      // Initialize refs for each row
      response.forEach((row) => {
        if (!printRefs.current[row.entry_id]) {
          printRefs.current[row.entry_id] = React.createRef();
        }
      });
    } catch (error) {
      setSuccessMessage("Error fetching data");
    }
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue);
    const params = {
      page: controller.page,
      size: searchValue === "" ? controller.rowsPerPage : totalCount,
      searchKey: searchValue,
    };
    try {
      await fetchData(params);
    } catch (error) {
      console.error("Error in handleSearch:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller.page, controller.rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setController((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setController({ page: 0, rowsPerPage: parseInt(event.target.value, 10) });
  };

  const deleteRecord = async (id) => {
    try {
      await maintenance.editDeletemaintenance({
        maint_id: id,
        changedUpdatedValue: "delete",
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (row) => {
    setDeleteInfo(row);
    setIsDelete(true);
  };

  const handleClose = () => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const dateConversion = (date) => {
    if (!date) return "";
    const today = new Date(date);
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  // Sort rows by entry_date descending
  const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));

  // Calculate pagination info
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count || 0}`;

  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: "0px !important", margin: "0px !important" }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: "Driver Activity Planning List" }]} />

        <HeaderSection
          title="DRIVER ACTIVITY PLANNING LIST"
          addNewPath="/storeEntries/add-dap"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={["entry_no", "entry_date", "depot_name", "driver_name", "vehicle_no", "start_km", "end_km", "start_time", "end_time"]}
          labels={["Entry No", "Entry Date", "Depot Name", "Driver Name", "Vehicle No", "Start KM", "End KM", "Start Time", "End Time"]}
          filename="Driver Activity List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
        />

        <Paper sx={{ width: "100%" }}>
          <TableContainer component={Paper} className={styles.list_tbl_container}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left" sx={{ minWidth: "100px !important" }} className={`${styles.table_head}`}>
                    Entry Date
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.table_head}`}>
                    Depot Name
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.table_head}`}>
                    Customer Name
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.table_head}`}>
                    Driver Name
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.table_head}`}>
                    Vehicle No
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.table_head}`}>
                    Start KM
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.table_head}`}>
                    End KM
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.table_head}`}>
                    Start Time
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.table_head}`}>
                    End Time
                  </StyledTableCell>
                  <StyledTableCell align="center" sx={{ minWidth: "70px !important" }} className={`${styles.table_head}`}>
                    Action
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: "#fff" }}>
                {Array.isArray(rows) &&
                  sortedRows.map((row, index) => {
                    // Parse table_details to extract customer_name
                    let customerName = "";
                    try {
                      const tableDetails = row.table_details ? JSON.parse(row.table_details) : [];
                      customerName = tableDetails[0]?.customer_name || "";
                    } catch (error) {
                      console.error("Error parsing table_details:", error);
                    }

                    return (
                      <StyledTableRow key={row.entry_id || index}>
                        <StyledTableCell align="left" sx={{ minWidth: "100px !important" }} className={`${styles.list_table_body}`}>
                          {dateConversion(row.entry_date)}
                        </StyledTableCell>
                        <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.list_table_body}`}>
                          {row.depot_name}
                        </StyledTableCell>
                        <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.list_table_body}`}>
                          {customerName}
                        </StyledTableCell>
                        <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.list_table_body}`}>
                          {row.driver_name}
                        </StyledTableCell>
                        <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.list_table_body}`}>
                          {row.vehicle_no}
                        </StyledTableCell>
                        <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.list_table_body}`}>
                          {row.start_km}
                        </StyledTableCell>
                        <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.list_table_body}`}>
                          {row.end_km}
                        </StyledTableCell>
                        <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.list_table_body}`}>
                          {row.start_time}
                        </StyledTableCell>
                        <StyledTableCell align="left" sx={{ minWidth: "120px !important" }} className={`${styles.list_table_body}`}>
                          {row.end_time}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <div style={{ display: "none" }}>
                            <ComponentToPrintWrapper ref={printRefs.current[row.entry_id]} quotationPrint={row} />
                          </div>
                          <CustomePopover
                            row={row}
                            handleDelete={handleDelete}
                            linkTo="/storeEntries/add-dap"
                            showEdit={true}
                            handlePrint={() => printRefs.current[row.entry_id].current} // Pass function returning ref
                          />
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={total_count || 0}
            rowsPerPage={controller.rowsPerPage}
            page={controller.page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>

        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.entry_id || null}
          displayName={deleteInfo?.entry_no || ""}
        />

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== "clickaway") setSuccessMessage("");
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default ListDriverActivityPlaning;